import {makeStyles} from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    fontFamily: 'Inter',
    color: 'white',
  },

  rightMainTitle: {
    color: theme.palette.black.dark,
    fontSize: '22px',
    fontWeight: 600
  },
  inputWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: "297px",
  },
  textInputWrapper: {
  },
  formLabel: {
    fontSize: '14px',
    fontWeight: 600,
    color: theme.palette.grey.grey500
  },
  textField: {
    marginTop: "8px",
    "& .MuiInputBase-root": {
      background: 'white'
    },
    "& .MuiOutlinedInput-root": {
      border: 0,
    }
  },
  textFieldError: {
    "& .MuiOutlinedInput-root": {
      color: "red",
    }
  },
}));

export default useStyles;